/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Trageți pentru a redimensiona panoul',
  command_intelligence_close_aria: 'Închide asistentul',
  command_intelligence_send_aria: 'Trimite mesaj',
  command_intelligence_stop_aria: 'Oprește răspunsul',
  command_intelligence_composer_input_aria: 'Mesaj către Command Intelligence',
  command_intelligence_drawer_more_options: 'Mai multe opțiuni',
  command_intelligence_dock_position: 'Poziția de andocare',
  command_intelligence_dock_left: 'Stânga',
  command_intelligence_dock_right: 'Dreapta',
  command_intelligence_dock_top: 'Sus',
  command_intelligence_dock_bottom: 'Jos',
  command_intelligence_panel_layout: 'Layout panou',
  command_intelligence_panel_layout_overlap: 'Suprapune conținutul',
  command_intelligence_panel_layout_push: 'Împinge conținutul',
  command_intelligence_panel_auto_hide_overlap: 'Ascunde automat la clic în afara',
  command_intelligence_session_reset: 'Resetează conversația',
  command_intelligence_try_one_of_these: 'Încercați una dintre acestea',
  command_intelligence_attach_hint: 'Atașați elemente de context pentru a începe să puneți întrebări.',
  command_intelligence_attach_modal_title: 'Atașează context',
  command_intelligence_attach_modal_subtitle:
    'Alegeți din elementele din această vizualizare. Elementele deja atașate sunt estompate.',
  command_intelligence_attach_modal_search_placeholder: 'Căutare…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# element disponibil} few {# elemente disponibile} other {# de elemente disponibile}} · {selected} selectate',
  command_intelligence_attach_modal_empty: 'Nimic disponibil de atașat',
  command_intelligence_attach_modal_no_results: 'Niciun element nu corespunde căutării',
  command_intelligence_context_bar_attached_section: 'Atașate ({count})',
  command_intelligence_context_bar_clear_attached: 'Șterge',
  command_intelligence_context_bar_add: 'Atașează context',
  command_intelligence_placeholder_ready: 'Puneți o întrebare…',
  command_intelligence_placeholder_attach: 'Atașați context pentru a pune o întrebare…',
  command_intelligence_composer_submit_hint: 'Enter pentru trimitere · Shift+Enter pentru linie nouă',
  command_intelligence_composer_stop_hint: 'Oprește · schiță pentru următorul mesaj în timp ce așteptați',
  command_intelligence_response_stopped: 'Răspuns oprit',
  command_intelligence_generation_in_progress: 'Se procesează întrebarea dvs.',
  command_intelligence_generation_trace_title: 'Pași efectuați',
  command_intelligence_generation_trace_toggle: 'Afișează pașii',
  command_intelligence_generation_trace_summary: '{completed} din {total} pași finalizați',
  command_intelligence_generation_trace_summary_generic: 'Pași de generare',
  command_intelligence_generation_tool_count:
    '{count, plural, one {# instrument} few {# instrumente} other {# de instrumente}}',
  command_intelligence_generation_turn_label: 'Turul {turn} din {total}',
  command_intelligence_generation_turn_completed: 'Turul {turn} din {total} finalizat',
  command_intelligence_generation_turn_completed_elapsed: 'Turul {turn} din {total} finalizat ({seconds}s scurse)',
  command_intelligence_generation_turn_completed_with_tools: 'Turul {turn} din {total} finalizat – a folosit {tools}',
  command_intelligence_generation_tools_used: 'A folosit {tools}',
  command_intelligence_reasoning_thinking: 'Gândesc…',
  command_intelligence_reasoning_thought_for_seconds: 'A gândit {seconds} secunde',
  command_intelligence_reasoning_waiting: 'Se procesează întrebarea dvs.…',
  command_intelligence_attach_modal_done: 'Gata',
  command_intelligence_attach_modal_attached_badge: 'atașat',
  command_intelligence_attach_modal_attach: 'Atașează',
  command_intelligence_attach_modal_attach_count: 'Atașează ({count})',
  command_intelligence_attach_modal_close_aria: 'Închide selectorul',
  command_intelligence_session_limit_context: 'Limita de context atinsă. Resetați conversația pentru a continua.',
  command_intelligence_session_limit_prompt: 'Limita de mesaje atinsă. Resetați conversația pentru a continua.',
  command_intelligence_suggested_followups: 'Urmăriri sugerate',
  command_intelligence_credit_warning_line: '{pct}% din creditele AI lunare pentru {scope} utilizate',
  command_intelligence_tooltip_prompts: '{count} din {max} mesaje ({pct}%)',
  command_intelligence_tooltip_context: '{used} din {max} tokeni de context ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Utilizarea contextului apare după primul răspuns',
  command_intelligence_credits_loading: 'Se încarcă creditele…',
  command_intelligence_credits_unavailable: 'Credite indisponibile',
  command_intelligence_credits_tooltip: 'Credite AI lunare pentru {monthKey}',
  command_intelligence_credits_tooltip_short: 'Credite AI lunare',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Entitate',
  command_intelligence_credits_used_of_cap: '{used} din {cap} credite',
  command_intelligence_credits_used_no_cap: '{used} credite utilizate',
  command_intelligence_credits_monthly_title: 'Credite AI lunare',
  command_intelligence_compare_aria: 'Compară agenții',
  command_intelligence_compare_tooltip: 'Rulează aceeași întrebare pe mai multe profiluri de agent',
  command_intelligence_compare_cancelled: 'Comparație anulată',
  command_intelligence_compare_branch_failed: 'Ramura de comparație a eșuat',
  command_intelligence_compare_title: 'Comparație agenți',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} intr. / {outTok} ieș. · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Răspuns bun',
  command_intelligence_feedback_bad_response: 'Răspuns slab',
  command_intelligence_feedback_dialog_title: 'Oferă feedback',
  command_intelligence_feedback_dialog_body:
    'Ajutați-ne să ne îmbunătățim oferind feedback despre acest răspuns. Feedbackul dvs. va fi trimis echipei noastre operaționale.',
  command_intelligence_feedback_response_label: 'Răspuns',
  command_intelligence_feedback_input_label: 'Feedbackul dvs. (opțional)',
  command_intelligence_feedback_input_placeholder: 'Ce a fost greșit sau nefolositor în acest răspuns?',
  command_intelligence_feedback_submit: 'Trimite feedback',
  command_intelligence_feedback_submit_error: 'Trimiterea feedbackului a eșuat. Încercați din nou.',
  command_intelligence_feedback_question_understanding: 'Agentul a înțeles ce doreați?',
  command_intelligence_feedback_question_readability: 'Răspunsul a fost ușor de citit și utilizat?',
  command_intelligence_feedback_section_understanding: 'Înțelegere',
  command_intelligence_feedback_section_readability: 'Lizibilitate',
  command_intelligence_feedback_choice_none: 'Niciunul',
  command_intelligence_feedback_choice_misunderstood_task: 'A înțeles greșit sarcina',
  command_intelligence_feedback_choice_ignored_constraint: 'A ignorat constrângerea',
  command_intelligence_feedback_choice_wrong_scope: 'Domeniu greșit',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Greu de citit vizual',
  command_intelligence_feedback_choice_wrote_too_much: 'A scris prea mult',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Explicație neîncredere',
  command_intelligence_copy_aria: 'Copiază în clipboard',
  command_intelligence_error_missing_invoke_permission:
    'Nu aveți permisiunea de a folosi Command Intelligence pentru acest agent. Cereți administratorului să acorde permisiunile Intelligence necesare (de exemplu, analyst).',
  command_intelligence_access_denied_title: 'Acces necesar',
  command_intelligence_error_session_expired: 'Sesiunea dvs. a expirat. Reîmprospătați pagina și conectați-vă din nou.',
};
